import React from 'react';
import Component from './Component';
import {TabGroup, Tab} from 'reactis-tabs';

export default class TabList extends Component {

	constructor(props)
	{
		super(props);
	}

	static defaultProps = {
		style: {indicator: {backgroundColor: '#26A69A'}}
	};

	handleChange(i) {
		let options = this.props.options;
		if (options.asArray) {
			options = options.asArray();
		}
		let item = options[i];

		if (this.props.onChange) {
			this.props.onChange(item.id)
		}
		if (this.props.onBlur) {
			this.props.onBlur(item.id)
		}
	}

	render() {
		let options = this.props.options;
		if (options.asArray) {
			options = options.asArray();
		}
		let value = 0;
		const tabs = options.map((item, index) => {
			if (item.id == this.props.value) {
				value = index;
			}
			return <Tab key={item.id}>{item.title}</Tab>;
		});

		return (
			<div className="tablist" style={{width: this.props.width, height: 30}}>
				<TabGroup selectedTab={value} onChangeTab={(i) => this.handleChange(i)} style={this.props.style}>
					{tabs}
				</TabGroup>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/TabList.js